import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { Toaster as ShadcnToaster } from "@/components/ui/toaster";
import { ThemeProvider } from "@/contexts/ThemeContext";

import Index from "@/pages/Index";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Create from "@/pages/Create";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import Templates from "@/pages/Templates";
import Workspace from "@/pages/Workspace";
import ABTesting from "@/pages/ABTesting";
import BatchCreate from "@/pages/BatchCreate";
import Leads from "@/pages/Leads";
import Gamification from "@/pages/Gamification";
import Security from "@/pages/Security";
import Status from "@/pages/Status";
import Pricing from "@/pages/Pricing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import About from "@/pages/About";
import Support from "@/pages/Support";
import Blog from "@/pages/Blog";
import NotFound from "@/pages/NotFound";
import BlogPostDetail from "@/pages/blog/[slug]";

import Contact from "@/pages/Contact";
import Shipping from "@/pages/Shipping";
import Refunds from "@/pages/Refunds";
import Admin from "@/pages/Admin";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <TooltipProvider>
        <Toaster position="top-right" richColors />
        <ShadcnToaster />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create" element={<Create />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/ab-testing" element={<ABTesting />} />
            <Route path="/batch" element={<BatchCreate />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/gamification" element={<Gamification />} />
            <Route path="/security" element={<Security />} />
            <Route path="/status" element={<Status />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Support />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPostDetail />} />
            
            <Route path="/contact" element={<Contact />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/refunds" element={<Refunds />} />
            <Route path="/admin" element={<Admin />} />
            
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
